import { Popup } from '../../../../../ui/popup/popup';

interface IFreeWithYourPurchasePopup {
    setPopupVisible: Function,
}

const FreeWithYourPurchasePopup = (props: IFreeWithYourPurchasePopup) => {

    const closeHandler = () => {
        props.setPopupVisible(false);
    };

    return (
        <Popup width="400px" height="270px" close={ closeHandler }>
            <div className="flex flex-col justify-center items-center w-full h-full my-4 text-center">

                <p className="mb-2 text-xl">Waves Update Plan</p>
                <p className="mb-4 px-6">All selected software products in your cart include free updates and access to Waves technical support for one year.</p>

                <button
                    type="button"
                    className="w-btn"
                    onClick={ closeHandler }
                    style={{ width: '170px' }}>OK</button>
            </div>
        </Popup>
    )
};

export default FreeWithYourPurchasePopup;